<template >
  <div
    v-loading="loading"
    :style="getElementStyle(data)"
  >
    <span
      v-if="isActive
      ||
      isDataTableField"
      class="setting-icon"
      @click="openSettings"
    >
      <i class="el-icon-s-tools" />
    </span>
   
    <img
      :src="getAuthorizedSignatureById.auth_sign_url"
      height="50"
    />
    <p>{{getAuthorizedSignatureById.name}}</p>
    <p>{{getAuthorizedSignatureById.designation}}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import templateBuilderHelper from "@/mixins/templateBuilderHelper";
export default {
  name: "AuthorizedSignatureView",
  components: {},
  props: ["data", "value", "isActive", "isDataTableField"],
  mixins: [templateBuilderHelper],
  computed: {
    ...mapGetters("company", ["getAuthorizedSignatureById"]),
    getStyle() {
      return `height:${this.data.height - 30}px`;
    }
  },
  data() {
    return {
      validations: [],
      options: [],
      loading: false
    };
  },
  mounted() {
    this.fetchAuthorizedSignature();
  },
  watch: {
    "data.authorized_signature"() {
      this.fetchAuthorizedSignature();
    }
  },
  methods: {
    copyDocument() {
    this.$emit("copy-document", this.data.key);
  },
    async fetchAuthorizedSignature() {
      this.loading = true;
      if (this.data.authorized_signature) {
        await this.$store.dispatch(
          "company/getCompanyAuthorizationSignatureById",
          {
            id: this.data.authorized_signature
          }
        );
      }
      this.loading = false;
    },
    openSettings() {
      this.$emit("settings");
    }
  }
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100% !important;
  .el-input,
  .el-input__inner {
    height: inherit !important;
  }
}
</style>